<template>
  <div id="course-create-details-tab">
    <div class="vx-col w-full">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.username" class="w-full" label-placeholder="Account Username" @change="labUpdateData" />
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-input v-model="dataLocal.password" class="w-full" label-placeholder="Account Password" @change="labUpdateData" />
        </div>
        <div class="vx-col w-1/3">
          <p class="text-sm">Lab Pool ID</p>
          <v-select placeholder="Lab Pool ID" :options="pools" v-model="dataLocal.pool" class="mt-1" @change="labUpdateData" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" type="filled" class="mb-2 mr-2" @click="submitData">Create Lab Account </vs-button>
          <vs-button color="warning" type="border" class="mb-2 ml-2" @click="resetData">Reset </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      module_description_counter: null,

      status_options: ['active', 'hidden', 'disabled'],

      pools: [],
    };
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    labUpdateData() {
      this.$emit('update_lab_data', this.dataLocal);
    },
    submitData() {
      this.$emit('insert_lab_data', this.dataLocal);
    },
    resetData() {
      this.dataLocal = { module_name: undefined, module_description: undefined, module_status: undefined };
      this.labUpdateData();
    },
    getPools() {
      this.$httpLabs
        .get('/labs/pools')
        .then((response) => {
          this.pools = response.data.rows.map((obj) => obj.id);
        })
        .catch(() => {
          // Error
        });
    },
  },
  created() {
    this.getPools();
  },
};
</script>

<style scoped></style>
